import CryptoJS from "crypto-js"

export default function generateSecretHash(username, clientId, clientSecret) {
    const data = username + clientId
    return CryptoJS.HmacSHA256(data, clientSecret).toString(CryptoJS.enc.Base64)
}